import {getApi} from '../../modules/common/utils/api'
const api = getApi('audit')

export function getValidName(name, type, id) {
  return api.post(`/api/v1/validate_name`, {
    name: name,
    type: type,
    id: id,
  })
}
